<form novalidate [formGroup]="form">
    <sq-modal
        [title]="'msg#modal.login.title'"
        [buttons]="buttons">
        <div class="mb-3 sq-form-group">
            <label class="form-label" for="userName">{{'msg#modal.login.userName' | sqMessage}}</label>
            <input [sqValidation]="form" type="text" class="form-control" id="userName" formControlName="userName" spellcheck="off" cdkFocusInitial>
        </div>
        <div class="mb-3 sq-form-group">
            <label class="form-label" for="password">{{'msg#modal.login.password' | sqMessage}}</label>
            <input [sqValidation]="form" type="password" class="form-control" id="password" formControlName="password" autocomplete="off" spellcheck="off">
        </div>
        <div class="mb-3 sq-form-group" *ngIf="!!providers">
            <label class="form-label" for="providerName">{{'msg#modal.login.singleSignOn' | sqMessage}}</label>
            <select class="form-select" id="providerName" formControlName="providerName" (change)="authenticate()">
                <option *ngFor="let provider of providers" [value]="provider.name" [hidden]="!provider.name" [disabled]="!provider.name">{{(provider.displayName || provider.name) | sqMessage}}</option>
            </select>
        </div>
    </sq-modal>
</form>